export default __webpack_public_path__ + "static/media/MaskingX.356cf31b.png";